<template>
  <div class="yh-page">
    <el-card v-loading="loading" :element-loading-text="loadingText">
      <el-row slot="header" type="flex" justify="start" align="middle" class="p-3" :gutter="10">
        <el-col :span="14">
          <span>
            <el-button type="primary" size="small" icon="el-icon-back" @click="() => {this.$router.go(-1)}">返回</el-button>
          </span>
        </el-col>
      </el-row>

      <el-collapse v-model="activeNames">
        <el-collapse-item title="订单概况" name="1">
          <el-row class="py-1">
            <el-col :span="2" :offset="1" class="font-weight-bold">会员名称</el-col>
            <el-col :span="8">{{ regist_info.customer_name }}</el-col>
            <el-col :span="2" class="font-weight-bold">创建时间</el-col>
            <el-col :span="9">{{ regist_info.create_time | parseTime }}</el-col>
          </el-row>
          <el-row class="py-1">
            <el-col :span="2" :offset="1" class="font-weight-bold">活动名称</el-col>
            <el-col :span="8">{{ regist_info.activity_dic.activity_name + '[' + regist_info.activity_dic.activity_type + ']' }}</el-col>
            <el-col :span="2" class="font-weight-bold">审核状态</el-col>
            <el-col :span="9">
              <span class="badge mr-1" :class="getStatusBadge(regist_info.check_status)">
                {{ regist_info.check_status_name }}
              </span>
            </el-col>
          </el-row>
          <el-row class="py-1">
            <el-col :span="2" :offset="1" class="font-weight-bold">签署状态</el-col>
            <el-col :span="8">
              <el-tag size="small" :type="regist_info.signature_status === '1' ? 'success' : 'danger'">
                {{ regist_info.signature_status_name_detail }}
              </el-tag>
            </el-col>
            <el-col :span="2" class="font-weight-bold">支付状态</el-col>
            <el-col :span="9">
              <el-tag size="small" :type="regist_info.pay_status === '1' ? 'success' : 'danger'">
                {{ regist_info.pay_status_name }}
              </el-tag>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="相关文书" name="2">
          <el-row class="py-1">
            <el-col>
              <el-button type="primary" @click="handleSelectionChange(apply_list)">制作文书</el-button>
            </el-col>
            <el-col>
              <el-table :data="attachments" style="width: 100%">
                <el-table-column label="原文件">
                  <template slot-scope="scope">
                    <el-link type="primary" @click="previewPdf(scope.row)">{{scope.row.name }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column label="签署文件">
                  <template slot-scope="scope">
                    <el-link type="primary" @click="previewPdf(scope.row.child_obj)">{{scope.row.child_obj.name }}</el-link>
                  </template>
                </el-table-column>
                <el-table-column min-width="15%" label="文件大小">
                  <template slot-scope="scope">
                    <span>{{scope.row.size | formatSize }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="20%" label="创建日期">
                  <template slot-scope="scope">
                    <span>{{scope.row.create_time | parseTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="20%" label="签署日期">
                  <template slot-scope="scope">
                    <span>{{scope.row.file_sign[0].sign_time | parseTime }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="20%" label="是否超时">
                  <template slot-scope="scope">
                    <span>{{scope.row.is_timeout }}</span>
                  </template>
                </el-table-column>
                <el-table-column property="status" label="签署状态" min-width="20%">
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content=getSignTooltip(scope.row)  placement="top">
                      <span>{{ scope.row.status === 2 ? '已签署' : 
                               scope.row.status === 1 ? '签署中' : 
                               scope.row.status === 0 ? '未签署' : ''}}</span>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 按钮组 -->
                <el-table-column align="left" label="操作" min-width="25%">
                  <template slot-scope="scope">
                    <el-tooltip effect="light" content="下载原文件" placement="top-start">
                      <el-button type="text"
                                @click="download(scope.row)"><i class="el-icon-download"></i></el-button>
                    </el-tooltip>
                    <el-tooltip effect="light" content="下载已签署文件" placement="top-start">
                      <el-button type="text"
                                @click="download(scope.row.child_obj)"><i class="el-icon-download"></i></el-button>
                    </el-tooltip>
                    <el-tooltip effect="light" content="发送签署" placement="top-start">
                      <el-button type="text" v-show="canSend(scope.row) && [1,2].indexOf(scope.row.status) == -1"
                                @click="showDialog(scope.row)"><i class="el-icon-s-claim"></i></el-button>
                    </el-tooltip>
                    <el-tooltip effect="light" content="撤销" placement="top-start">
                      <el-button type="text" v-show="(scope.row.file_sign.length != 0) && [0, 1].indexOf(scope.row.file_sign[0].sign_flow_status) !== -1"
                                @click="handleRevokeSign(scope.row.file_sign[0].id)"><i class="el-icon-s-release"></i></el-button>
                    </el-tooltip>
                    <el-tooltip effect="light" content="签署链接" placement="top-start">
                      <el-button type="text" v-show="scope.row.file_sign[0].receiver"
                                @click="signUrl(scope.row.file_sign[0].id)"><i class="el-icon-link"></i></el-button>
                    </el-tooltip>
                    <el-tooltip effect="light" content="催签" placement="top-start">
                      <el-button type="text" v-show="scope.row.file_sign[0].receiver"
                                @click="handleUrgeSign(scope.row.file_sign[0].id)"><i class="el-icon-alarm-clock"></i></el-button>
                    </el-tooltip>
                    <el-tooltip effect="light" content="上传已签署" placement="top-start" v-show="!scope.row.child">
                      <el-upload
                        class="margin-change"
                        action=""
                        :auto-upload=true
                        :http-request="handleUploadFile"
                        :show-file-list="false"
                        :file-list="file_list"
                        :limit="1">
                        <el-button type="text" @click="() => {file_id = scope.row.id}"><i class="el-icon-upload2"></i></el-button>
                      </el-upload>
                    </el-tooltip>
                    <el-tooltip effect="light" placement="top-start" content="删除">
                      <el-button type="text" v-show="scope.row.status === null"
                        @click="handleDelete(scope.row)" >
                        <i class="el-icon-delete"></i>
                      </el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="业务清单" name="3">
          <el-table border show-summary :data="apply_list">
            <!--<el-table-column prop="customer_name" label="会员名称"></el-table-column>-->
            <el-table-column prop="ship_name" label="船名"></el-table-column>
            <el-table-column label="申请状态">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.status_name }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="pay_gross_ton" label="缴费总吨"></el-table-column>
            <el-table-column prop="big_premium" label="大桥险保费(元)"></el-table-column>
            <el-table-column prop="risk_premium" label="本期风险准备金(元)"></el-table-column>
            <el-table-column prop="small_premium" label="小桥险保费(元)"></el-table-column>
            <el-table-column prop="dues" label="入会会费(元)"></el-table-column>
            <el-table-column prop="total_amount" label="合计费用(元)"></el-table-column>
            <el-table-column align="left" label="支付状态" width="120px">
              <template slot-scope="scope">
                <el-tag size="small" :type="scope.row.finance_is_account ? 'success' : 'warning'">
                  {{ scope.row.finance_is_account ? '已到账' : '未到账'}}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="pay_time" label="缴费截止日期"></el-table-column>
            <el-table-column label="申请延长缴费">
              <template slot-scope="scope">
              <el-button size="small" @click="handlePayDateApply(scope.row)">申请延长缴费</el-button>
            </template>
            </el-table-column>
            <el-table-column>
              <template slot-scope="scope">
              <el-button size="small"  type="text" @click="handleDeleteApply(scope.row)">删除该条申请</el-button>
            </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item title="到账列表" name="4">
          <el-table border :data="finance_list">
            <!-- ID -->
            <el-table-column align="left" label="ID"  width="50px">
              <template slot-scope="scope">
                <span>{{scope.row.id}}</span>
              </template>
            </el-table-column>

            <!-- 状态 -->
            <el-table-column align="left" label="状态" width="150px">
              <template slot-scope="scope">
                <span v-if="scope.row.is_account" class="badge mr-1 badge-success">已到账</span>
                <span v-else class="badge mr-1 badge-warning">未到账</span>
                <span v-if="scope.row.is_invoice" class="badge mr-1 badge-success">已开票</span>
                <span v-else class="badge mr-1 badge-warning">未开票</span>
              </template>
            </el-table-column>

            <!-- 应到金额 -->
            <el-table-column align="left" label="应到金额">
              <template slot-scope="scope">
                <span>{{ scope.row.sum_amount | parsecurrency}}</span>
              </template>
            </el-table-column>

            <!-- 到账金额 -->
            <el-table-column align="left" label="到账金额">
              <template slot-scope="scope">
                <span>{{ scope.row.account | parsecurrency}}</span>
              </template>
            </el-table-column>
    
            <!-- 开票金额 -->
            <el-table-column align="left" label="开票金额">
              <template slot-scope="scope">
                <span>{{ scope.row.invoice | parsecurrency}}</span>
              </template>
            </el-table-column>

            <!-- 不开票金额 -->
            <el-table-column align="left" label="不开票金额">
              <template slot-scope="scope">
                <span>{{ scope.row.no_invoice | parsecurrency}}</span>
              </template>
            </el-table-column>
    
            <!-- 创建日期 -->
            <el-table-column align="left" label="创建日期">
              <template slot-scope="scope">
                <span>{{ scope.row.create_time | parseTime }}</span>
              </template>
            </el-table-column>
    
            <!-- 操作 -->
            <!--
            <el-table-column align="left" label="操作" width="100px">
              <template slot-scope="scope">
    
                <el-tooltip effect="light" content="开票确认" placement="top-start">
                  <el-button type="text" class="pr-1" @click="handleViewReceivable(scope.row)">
                    <i class="el-icon-notebook-1"></i>
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
            -->
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </el-card>

    <make-document-dialog ref="makeDocument"
                          :command_list="command_list"
                          :data="multipleSelection">
    </make-document-dialog>

    <el-dialog title="选择文书类型" :visible.sync="outerVisible" :show-close="false">
      <el-checkbox-group v-model="command_list">
        <el-checkbox v-for="item in command_options" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
      </el-checkbox-group>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" :disabled="command_list.length === 0" @click="openBatchExport">开始制作文书</el-button>
      </div>
    </el-dialog>
    
    <el-dialog title="签署人选择" :visible.sync="dialogFormVisible" :show-close="false">
      <el-form label-position="left" label-width="150px">
        <el-form-item label="签署方类型">
          <el-radio-group v-model="signer_type">
            <el-radio :label="0">个人</el-radio>
            <el-radio :label="1">公司</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="签署人">
          <el-select v-model="signer_mobile" filterable placeholder="请选择签署人">
            <el-option v-for="contact in contacts" :key="contact.id" 
            :label="contact.name + '(' + restricted_mobile(contact.mobile) + ')'"
            :value="contact.mobile"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="signer_type === 1" label="签署方公司名称">
          <el-select v-model="signer_org_name" filterable placeholder="请选择签署方公司名称">
            <el-option v-for="org in org_list" :key="org.id"
                :label="org.name" :value="org.name"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancelSend">取 消</el-button>
        <el-button :disabled="signer_mobile === ''" type="primary" @click="sendSign">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="pdfname" :visible.sync="previewVisible">
      <vue-pdf-preview :url="pdfUrl"></vue-pdf-preview>
    </el-dialog>
  </div>
</template>

<script>
import { getRegistDetail, getApplyList,PayDateApply,CreatePayDateApply,DeleteRegistApply, GetFinanceList} from '@/api/group-insurance'
import {fetchCustomer, fetchCustomerContactList} from '@/api/customer'
import { fetchInsuranceObjectFileList } from '@/api/common'
import { formatCurrency, formatSize } from '@/utils/misc'
import {download, getSignTooltip} from '@/utils'
import {signFile, deleteFile, urgeSign, revokeSign, getSignUrl} from '@/api/sign'
import {uploadChildFile} from "@/api/upload"
import MakeDocumentDialog from './make-document-dialog'
// import Pagination from '@/components/Pagination'
import VuePdfPreview from "@/components/VuePdfPreview"

export default {
  components: {
    // Pagination,
    MakeDocumentDialog,
    VuePdfPreview
  },
  filters: {
    formatSize,
    parsecurrency: function(value){
      let v = parseFloat(value).toFixed(4)
      return formatCurrency(v, 2)
    },
  },
  computed: {
  },
  data() {
    return {
      file_id: '',
      file_list: [],
      previewVisible: false,
      pdfname: '',
      pdfUrl: '',
      loading: false,
      loadingText: '正在加载数据，请稍等...',
      regist_id: '',
      regist_info: {
        activity_dic: {}
      },
      activeNames: ["1", "2", "3", "4"],
      apply_list: [],
      attachments: [],
      outerVisible: false,
      command_options: [
        {value: 'one', label: '企业会员入会申请书'}, 
        {value: 'two', label: '个人会员入会申请书'}, 
        {value: 'three', label: '船舶入会申请书'}, 
        {value: 'four', label: '缴费通知书'}, 
        {value: 'five', label: '活动参加申请书'}, 
        {value: 'six', label: '互助保障活动说明书'}, 
        {value: 'seven', label: '互助保障活动说明书（附加4项）'},
        {value: 'eight', label: '互助保障活动说明书-华翔'},
        {value: 'nine', label: '互助保障活动说明书（附加4项）-华翔'}
      ],
      command_list: [],
      multipleSelection: [],
      dialogFormVisible: false,
      contacts: [],
      org_list: [],
      signer_mobile: '',
      signer_type: 0,
      signer_org_name: '',
      file: {},
      query:{
        search: '',
        limit: 10,
        offset: 0,
      },
      finance_list: [],
    }
  },
  computed: {},
  methods: {
    download,
    getSignTooltip,
    restricted_mobile(mobile) {
      if (mobile && !this.$perm(['contact.list_contact']) && !this.$perm(['contact.all_contact']) && this.$perm(['contact.restricted_list_contact'])) {
        let value = mobile.slice(0, 3)
        var l = mobile.slice(3, 7).length
        for (var i=0; i<l; i++) {
          value += '*'
        }
        value += mobile.slice(7)
        return value
      }
      return mobile
    },
    canSend(row) {
      let can = false
      if (row.file_sign.length == 0) {
        can = true
      }
      else if (! row.file_sign[0].receiver || row.file_sign[0].sign_flow_status === 3) {
        can = true
      }
      return can
    },
    handleDeleteApply(row){
      if (this.apply_list.length === 1){
        this.$error_message("该订单仅有一条申请，请直接取消订单！")
              return
      }
      var msg = '是否删除该条船舶，对应的账单也会删除？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            DeleteRegistApply({'id':row.id})
              .then(res => {
                this.$message({
                  type: 'success',
                  message: '删除成功！'
                });
                this.loadData()
              })
              .catch(err => {
                this.$error_message(err)
              })
          })
    },

    handlePayDateApply(row){
          var msg = '可延迟缴费时间为业管部审核通过后的24小时内，是否申请延长缴费时间？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            CreatePayDateApply(row)
              .then(res => {
                this.$message({
                  type: 'success',
                  message: '成功提交申请！'
                });
              })
              .catch(err => {
                this.$error_message(err)
              })
          })
    },

    getStatusBadge(value) {
      let badge = 'badge-dark'
      switch (value) {
        case '0':
          badge = 'badge-secondary'
          break
        case '1':
          badge = 'badge-warning'
          break
        case '2':
          badge = 'badge-success'
          break
        case '3':
          badge = 'badge-danger'
          break
        default:
          badge = 'badge-dark'
      }

      return badge
    },
    loadData() {
      this.loading = true
      let p =[]
      p.push(getRegistDetail(this.regist_id))
      p.push(getApplyList({'registration_id': this.regist_id}))
      p.push(fetchInsuranceObjectFileList('group_insurance.insuranceregistration', this.regist_id))
      p.push(GetFinanceList({'registration_id': this.regist_id}))
      Promise.all(p).then(res => {
        // console.log(res)
        this.loading = false
        this.regist_info = res[0]
        this.apply_list = res[1]
        this.attachments = res[2]
        this.finance_list = res[3]
        console.log(this.attachments)
        this.already_num = 0 
        this.signing_num = 0
        this.no_num = 0
        this.attachments.forEach(att => {
              if(att.status === 2){
                this.already_num += 1
              }
              else if(att.status === 1){
                this.signing_num += 1
              }
              else{
                this.no_num += 1
              }
            })
        console.log(this.no_num)
        this.regist_info.signature_status_name_detail = '已签署：'+ this.already_num + ' 签署中：' +this.signing_num + ' 未签署：'+ this.no_num
        this.org_list = res[0].customer_type === '0' ? [{id: res[0].customer, name: res[0].customer_name}] : []
        fetchCustomerContactList(res[0].customer)
          .then(res => {
            this.contacts = res
          })
          .catch(err => {
            console.log(err)
          })
      }).catch(err => {
        this.loading = false
        this.$message.error(err)
      })
  
    },
    showDialog(row) {
      this.dialogFormVisible = true
      this.file = row
    },
    handleCancelSend() {
      this.dialogFormVisible = false
      this.signer_mobile = ''
      this.file = {}
    },
    sendSign() {
      const text = '是否发送文书' + '《' + this.file.name + '》至' + this.restricted_mobile(this.signer_mobile) + '进行签署？'
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dialogFormVisible = false
        this.loading = true
        this.$set(this.file, 'signer_mobile', this.signer_mobile)
        this.$set(this.file, 'signer_type', this.signer_type)
        this.$set(this.file, 'signer_org_name', this.signer_type === 1 ? this.signer_org_name : '')
        signFile(this.file)
        .then(res => {
          // console.log(res)
          this.$message({
            type: 'success',
            message: '已通知手机号为: ' + this.restricted_mobile(this.signer_mobile) + ' 的客户进行签署'
          });
        })
        .catch((err) => {
          this.$message.error({
            message: err
          });
        }).finally(() => {
          this.loading = false
          this.loadData()
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消发送签署'
        });       
      });
    },
    reset_commands() {
      return [
        {value: 'one', label: '企业会员入会申请书'}, 
        {value: 'two', label: '个人会员入会申请书'}, 
        {value: 'three', label: '船舶入会申请书'}, 
        {value: 'four', label: '缴费通知书'}, 
        {value: 'five', label: '活动参加申请书'}, 
        {value: 'six', label: '互助保障活动说明书'}, 
        {value: 'seven', label: '互助保障活动说明书（附加4项）'},
        {value: 'eight', label: '互助保障活动说明书-华翔'},
        {value: 'nine', label: '互助保障活动说明书（附加4项）-华翔'}
      ]
    },
    handleCancel() {
      this.command_list = []
      this.outerVisible = false
    },
    handleSelectionChange(val) {
      this.outerVisible = true
      // 根据客户类型选择个人入会申请 or 企业入会申请
      this.command_options = this.reset_commands()
      if (val.length > 0) {
        if (val[0]["customer_type"] === "0") {
          this.command_options.splice(1, 1)
        }
        else if (val[0]["customer_type"] === "1") {
          this.command_options.splice(0, 1)
        }
      }

      this.multipleSelection = val;
      this.multipleSelection.forEach(f => {
        this.$set(f,'is_check1',false)
        this.$set(f,'is_check2',false)
        this.$set(f,'is_check3',false)
        this.$set(f,'is_check4',false)
        // this.$set(f,'allpeople',"")
        this.$set(f,'remark',"")
        this.$set(f,'customer_relation', "")
      })
    },
    openBatchExport() {
      this.$refs.makeDocument.handleMake()
    },
    handleUploadFile(param) {
      let file = param.file
      let fd = new FormData()

      fd.append("file", file)
      fd.append("object_id", this.regist_id)
      fd.append("object_type", "group_insurance.insuranceregistration")
      fd.append("new_name", file.name)
      fd.append("org_file_id", this.file_id)
      // console.log(fd)
      uploadChildFile(fd)
        .then(res => {
          param.onSuccess(res)
          this.loadData()
        })
        .catch(error => {
          param.onError(error)
          error_message(error)
        })
    },
    previewPdf(file){
      this.pdfname = file.name
      this.pdfUrl = file.url
      this.previewVisible = true
    },
    handleDelete(row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.loading = true
        deleteFile({'id': row.id}).then(res => {
          this.loading = false
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.loadData()
        }).catch(err => {
          this.loading = false
          this.$error_message(err)
        })
      })
    },
    handleUrgeSign(sign_id) {
      urgeSign(sign_id)
      .then(res => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: '已发送催签短信'
          })
        }
        else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      })
      .catch(err => {
        console.log(err)
      })
    },
    signUrl(sign_id) {
      getSignUrl(sign_id)
      .then(res => {
        if (res.code === 0) {
          this.$alert('签署链接为：' + res.data.shortUrl)
        }
        else {
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      })
      .catch(err => {
        console.log(err)
      })
    },
    handleRevokeSign(sign_id) {
      this.$confirm('是否撤销签署', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        revokeSign({'sign_id': sign_id}).then(res => {
          this.loading = false
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '已撤销签署'
            })
            this.loadData()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            })
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
      })
    },
    handleViewReceivable(row) {
      // this.setQueryStorage()
      this.$router.push({ name: 'ReceivableDetail', query: {id: row.id}})
    },
  },
  beforeRouteLeave (to, from, next) {
    if (to.name != 'RegistList') {
      window.localStorage.removeItem('query')
    }
    next()
  },
  created() {
    // 入参处理
    if (this.$route.query.id === undefined){
      this.$router.push('/404')
    }
    this.regist_id = this.$route.query.id

    this.loadData()
  }
}
</script>

<style>
  .inline-block {
  display: inline-block;
  margin-right:10px; 
  }

  .margin-change{
   display: inline-block;
   margin-left:10px;
   margin-right:10px; 
   }

</style>